import styled from 'styled-components'

import check from './images/icon-check.svg';

export const Container = styled.div`
  min-height: 80vh;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  font-variant-numeric: proportional-nums;
`


export const Wrap = styled.div`
    max-width: 1440px;
    padding: 0 50px;
    margin: 0 auto;
    position: relative;
`

export const WelcomeBlock = styled.div`
    padding: 120px 0 0 0;
    background-color: #fff;
`
export const WelcomeTitle = styled.div`
  text-align: center;
  max-width: 880px;
  padding: 77px 0 0;
  margin: 0 auto 23px;
  color: #fff;
  
  p{
    margin-bottom: 0;
  }
  
  h1{
    margin: 0 0 40px;
    font-size: 50px;
    line-height: 62px;
    letter-spacing: -.02em;
  }
  
  p a{
      color: #fff;
      background: #4378FF;
      display: inline-block;
      cursor: pointer;
      font-size: 18px;
      line-height: 32px;
      padding: 8px 18px;
      white-space: nowrap;
      height: 48px;
      border-radius: 10px;
      border: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      transition: .3s all;
      box-sizing: border-box;
    }
`
export const WelcomeScreen = styled.div`
    display: flex;
    margin: 80px 0 57px;
    position: relative;
    z-index: 5;
`
export const WelcomeIphone = styled.div`
    width: 22%;
    transform: rotate(0);
    transition: 1s transform;
    margin-right: 4.5%;
    display: flex;
    align-content: center;
    line-height: 0;

    img{
      filter: drop-shadow(0 0 10px rgba(0,0,0,.1));
      width: 100%;
    }
    
`
export const WelcomeWeb = styled.div`
    width: 73.5%;
    display: flex;  
    align-content: center;
    line-height: 0;
    
    img{
      filter: drop-shadow(0 0 10px rgba(0,0,0,.1));
      width: 100%;
    }
`
export const WelcomeFunction = styled.div`
    background: #3c3c3c;
    position: relative;
    z-index: 1;
    padding: 80px 0 72px;
    
    h2{
      color: #fff;
      font-weight: 600;
      font-size: 32px;
      line-height: 44px;
      margin: 20px 0;
      letter-spacing: -.02em;
      text-align: center;
    }
    
    :before{
      height: 340px;
      left: 0;
      right: 0;
      top: -340px;
      display: block;
      position: absolute;
      content: "";
      background: no-repeat center center;
      background-size: 100% 340px;
`
export const Functions = styled.div`
    margin: 40px 0 0;
    color: #fff;
    display: flex;
    justify-content: center;

    & > div{
      width: 22%;
    }
  
    & > div > div{
      width: 100%;
      padding-left: 47px;
      padding-right: 10%;
      vertical-align: top;
      margin: 18px 0;
      display: inline-block;
      position: relative;
      
      :before{
        background-image: url(${check});
        width: 27px;
        height: 24px;
        top: 2px;
        position: absolute;
        left: 0;
        content: "";
        display: block;
      }
    }
`

export const TryNow = styled.div`
    height: 230px;
    text-align: center;

    & > div > form{
      display: inline-block;
      width: 100%;
      max-width: 600px;
    }
    & > div > form > div{
      margin: 10px 0;
      display: flex;
    }
    & > div > form > div:last-child{
      margin-bottom: 0;
    }
    & > div > form > div:first-child{
      margin-top: 0;
    }
    & > div > form > div > .input{
      width: 100%;
      margin-right: 16px;
    }
    & > div > form > div > .input > input{
      background: rgba(0,0,0,.05);
      color: #000;
      border-radius: 10px;
      padding: 8px 18px;
      font-size: 18px;
      line-height: 32px;
      height: 48px;
      border: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      transition: .3s all;
      width: 100%;
    }
    & > div > form > div > .submit{
      width: 150px;
    }
    & > div > form > div > .submit > button{
      color: #fff;
      background: #4378FF;
      display: inline-block;
      cursor: pointer;
      font-size: 18px;
      line-height: 32px;
      padding: 8px 18px;
      white-space: nowrap;
      height: 48px;
      border-radius: 10px;
      border: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      transition: .3s all;
    }
    
`

export const Blocks = styled.div`
    background-color: #262732;
    
    :after{
      display: block;
      clear: both;
      content: "";
    }
`

export const BlockText = styled.div`
    width: 50%;
    margin: 50px 0;
  
    color: #fff;
`

export const BlockPic = styled.div`
    width: 50%;
    margin: 50px 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    
    & > .block-pics-1, & > .block-pics-2, & > .block-pics-3, & > .block-pics-4, & > .block-pics-5{
      position: relative;
      width: 100%;
    }

    .window-img{
      width: 100%;
    }
    
    .window-img img{
      width: 100%;
    }
    
    .chat-img{
      right: 2.5%;
      top: 68%;
      width: 62%;
      position: absolute;
      z-index: 2;
    }
    
    .chat-img img{
      width: 100%;
    }

  @media (max-width: 550px) {
      display: none;
    
  }
  
  //@media (min-width: 1000px) {
  //  &{
  //    display: flex;
  //  }
  //}
`

export const BlockOdd = styled.div`
    max-width: 1440px;
    padding: 0 50px;
    margin: 0 auto;
    position: relative;

    & > div{
      display: flex;
      min-height: 542px;
      align-items: center;
    }
    
    & > div > div:first-child{
      margin-right: 50px;
    }

  @media (min-width: 550px) {
    img{
      display: none;
    }
  }
  
  @media (min-width: 1000px) {
    img{
      display: flex;
    }
  }
`

export const BlockEven = styled.div`
    max-width: 1440px;
    padding: 0 50px;
    margin: 0 auto;
    position: relative;


    & > div{
      display: flex;
      min-height: 542px;
      align-items: center;
    }
    
    
`

export const BlackSwan = styled.div`
    padding: 100px 0;
    color: #fff;
    text-align: center;

    a.black-swan-logo
    {
        text-align: center;
        background-size: 141px 22px;
        width: 141px;
        display: inline-block;
        padding-bottom: 30px;
        margin: 0 0 20px 0;
        
        :before{
          content: "";
          width: 55px;
          height: 44px;
          display: inline-block;
        }
    }
    
    h1{
        color: #fff;
        text-align: center;
    }
    
    p.link{
      margin-top: 40px;
      height: 40px;
      line-height: 0;
    }
    
    p a{
      color: #fff;
      background: #4378FF;
      display: inline-block;
      cursor: pointer;
      font-size: 18px;
      line-height: 32px;
      padding: 8px 18px;
      white-space: nowrap;
      height: 48px;
      border-radius: 10px;
      border: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      transition: .3s all;
      box-sizing: border-box;
    }
    
`

export const Footer = styled.div`
    min-height: 230px;
    background: #3c3c3c;
    height: 285px;
    padding: 32px 0 24px;
    color: #fff;
    
    & > div{
      display: flex;
      justify-content: space-between;
    }
    
    & > div:first-child{
      margin-bottom: 70px;
    }
    
    a{
      color: #fff;
    }
    a:hover{
      color: rgba(255, 255, 255, 0.6);
    }
`

export const FooterLeft = styled.div`
  div.footer-copyright {
    font-size: 14px;
    line-height: 24px;
    display: block;
    
    a {
        color: #929292;
        font-size: 14px;
        line-height: 16px;
        border-bottom: solid 1px rgba(0,0,0,.1);
        margin-right: 16px;
        
        :hover{
          color: rgba(0,0,0,1);
          border-bottom: solid 1px rgba(0,0,0,.2);
        }
    }
  }
    
`

export const FooterRight = styled.div`
  white-space: nowrap;  
    
  div.footer-phone, div.footer-email{
    display: inline-block;
    margin-right: 80px;
  }
  
  
`
